import { AsyncComboBox, type ComboBoxOption } from '../../../cdl/ComboBox/ComboBox';
import { getCustomerDetails, getCustomers, type GetCustomersParams } from '../../api/clients/company.api';
import { queries } from '../../api/queryKeys/queries';
import { formatCompanyName } from '../../helpers/formatCompanyName.helper';
import type { AsyncSingleSelectProps } from '../AsyncSelectProps';

export interface CustomerCompanySelectProps extends AsyncSingleSelectProps {
    onChange: (customerId: string) => void;
    groupId?: string;
    value: string;
}

const loadCustomers = async (params: GetCustomersParams): Promise<ComboBoxOption[]> => {
    const customers = await getCustomers(params);

    return customers.map((company) => ({
        value: company.id,
        label: formatCompanyName({
            company,
        }) as ComboBoxOption['label'],
    }));
};

const loadCustomer = async (customerId: string): Promise<ComboBoxOption | null> => {
    const company = await getCustomerDetails(customerId);

    return {
        value: company.id,
        label: formatCompanyName({
            company,
        }) as ComboBoxOption['label'],
    };
};

export function CustomerCompanySelect({ groupId, value, onChange, ...rest }: CustomerCompanySelectProps) {
    return (
        <AsyncComboBox
            {...rest}
            value={value || null}
            onChange={(nextValue) => onChange(nextValue ?? '')}
            optionsQueryKey={(search) => queries.customers.comboBoxOptions({ searchQuery: search, groupId }).queryKey}
            optionsQueryFn={(search) => loadCustomers({ searchQuery: search, groupId })}
            selectedOptionQueryKey={(selectedValue) => queries.customers.selectedComboBoxOption(selectedValue).queryKey}
            selectedOptionQueryFn={loadCustomer}
        />
    );
}
